export const RESPONSIVE_BREAKPOINTS = {
  tabletPortrait: '(max-width: 768px)',
} as const;
